<template>
    <page title="404 - Page not found" full>
        <div class="warning">
            <h1>404</h1>
            <p>Page not found.</p>
            <button class="btn btn-outline-success" @click="$router.push({name: 'Home', params: $route.params})">
                <i class="fa fa-long-arrow-left"></i> Return Home
            </button>
        </div>
    </page>
</template>

<script>
import Page from './utilities/Page'

export default {
  name: 'PageNotFound',
  components: {Page},
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue